export default {
  Title: 'Tags | Tag | Tags',

  SelectTagDialog: {
    Title   : 'Tags',
    Subtitle: 'Select tag'
  },

  Message: {
    NoItems: {
      Title   : 'No products available',
      Subtitle: 'Choose another tag from the menu'
    }
  }
}
